/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';


const VehicleDropdown = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [vehicleData, setVehicleData] = useState([]);

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}/masters/vehicleMaster`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setVehicleData(response.data.resultSet)
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])


    let options = []
    if (vehicleData && vehicleData.length > 0) {
        vehicleData.map((object, index) => {
            let temp = {}
            temp.key = object.vehicleMasterId
            temp.text = object.vehicleNumber
            temp.value = object.vehicleMasterId
            return options[index] = temp
        })
    }

    const handleOnChange = (e, data) => {
        setFieldValue(name, data.value);
    }

    return (
        <Dropdown
            search
            selection
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            {...props}
            fluid
        />
    )
}


export default VehicleDropdown